module.exports = __webpack_public_path__ + "static/img/memory5.d4534eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memory5.jpg
// module id = XwH8
// module chunks = 1